import { useMemo } from "react";
import { SortDescriptor } from "react-aria-components";

import { ManagedUser } from "types/generated";

import { sortUsers } from "./sortUsers";

export const useSortedUsers = (users: ManagedUser[], sortDescriptor: SortDescriptor) => {
  return useMemo(() => {
    // Apply sorting if descriptor exists
    const sortedUsers = sortUsers(users, sortDescriptor);

    return sortedUsers;
  }, [users, sortDescriptor]);
};
